<template>
<page :title="'数说服务'">
  <div>
    <div id="map" style="width: 800px; height: 600px"></div>
  </div>
</page>
</template>
<script>

import Mapdata from '../../assets/data/100000_full.json'
import '../../../node_modules/echarts/map/js/china.js'
export default {
  name: 'Casemap',
  data () {
    return {
      mapJson: []
    }
  },
  methods: {
    drawChart () {
      this.mapJson = Mapdata
      // 对获取的每个子区域添加 name:省市区名称  value 要展示的值  level 此区域的省市区等级  cityCode：省市区的code
      // 可通过需求自行添加和修改
      var value = 0
      this.mapData = this.mapJson.features.map(item => {
        value = value + 1
        var color = ['#3a9cf2', '#00c6c0', '#e8684a', '#6dc8ec', '#6ccff7', '#9270ca', '#b796ed', '#f5a360']
        var cindex = value % 8
        return ({
          name: item.properties.name,
          value: value++,
          level: item.properties.level,
          cityCode: item.properties.adcode,
          itemStyle: {
            areaColor: color[cindex],
            opacity: 0.5
          }
        })
      })
      console.log(this.mapData)
      this.init()
    },
    init () {
      var myChart = this.$echarts.init(document.getElementById('map'))
      var mapData = this.mapData
      // this.$echarts.registerMap('cityMap', this.mapJson, {})
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: (p) => {
            let val = p.value
            if (window.isNaN(val)) {
              val = 0
            }
            var txtCon = '<div style="text-align:center"> 地区：' + p.name + '</div>'
            return txtCon
          },
          selectedMode: false,
          color: ['#E0022B', '#E09107', '#A3E00B']
        },
        geo: { // 这个是重点配置区
          map: 'china', // 表示中国地图
          roam: true,
          regions: this.mapData,
          label: {
            normal: {
              show: true, // 是否显示对应地名
              textStyle: {
                color: 'rgba(0,0,0,0.4)'
              }
            }
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.2)'
            },
            emphasis: {
              areaColor: null,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        },
        visualMap: {
          left: 'right',
          min: 0,
          max: 80,
          inRange: {
            color: ['#3a9cf2', '#00c6c0', '#e8684a', '#6dc8ec', '#6ccff7', '#9270ca', '#b796ed', '#f5a360']
          },
          show: false,
          calculable: true
        },
        series: [
          {
            name: '地图',
            type: 'map',
            mapType: 'cityMap',
            aspectScale: 0.85,
            itemStyle: {
              normal: {
                label: { show: true },
                borderColor: 'rgba(100,149,237,1)',
                borderWidth: 0.5,
                areaStyle: {
                  color: 'rgba(0, 0, 0, 0)'
                }
              },
              emphasis: { label: { show: false } }
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: '#fff'
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: '#333'
                }
              }
            },
            data: mapData
          }
        ]
      }
      myChart.setOption(option)
      myChart.on('click', function (params) {
        console.log(params)
        // alert('s')
      })
    }
  },
  mounted () {
    this.drawChart()
  }
}
</script>
<style>
</style>
